<template>
<div class="container">
  <div class="nei">
    <div class="title">
      <span class="con">{{msg.name}}</span>
      <a  href="#"  @click="toList(msg.id)">更多></a>
    </div>
    <div class="img">
      <img :src="tuList.img" alt="">
      <div class="title-img"><span>{{tuList.title}}</span></div>
    </div>
    <ul>
      <li v-for="(item,index) in msg.content"
      :key="index"
      v-if="index<6"
          @click="toDetail(item.id)">
        <a href="#">
          <img :src="dian" class="dian" alt="">
          {{item.title}}
        </a>
        <span>{{'【'+item.check_time+'】'}}</span>
      </li>
    </ul>
  </div>
</div>
</template>

<script>
import dian from '@/assets/dian.png'
export default {
  name: "Tabs1",
  props:{
    midList:{
      type:Object,
    }
},
  watch:{
    midList:function (){
      this.msg=this.midList
      this.tuList={
        img:this.midList.content[0].thumbnail,
        title:this.midList.content[0].title,
      }
    }
  },
  data(){
    return{
      dian:dian,
     msg:{},
     tuList:{}
    }
  },
  methods:{
    toList (id) {
      this.$router.push(`/news/${id}`)
    },
    toDetail(id){
      this.$router.push(`/content/${id}`)
    }
  }
}
</script>

<style scoped>
.container{
  width: 362px;
  height: 435px;
  background-color: white;
  /*margin-right: 20px;*/
  padding: 15px;
}
.dian{
  position: relative;
  top:2px;
  width: 15px;
  height: 15px;
}
.img{
  position: relative;
  overflow: hidden;
}
.img>.title-img{
  position: absolute;
  bottom: 4px;
  height: 13%;
  width: 100%;
  background-color: rgba(0,0,0,0.5);
  color: white;
  line-height: 30px;
}
.img>.title-img>span{
  margin-left: 10px;
}
.img>img{
  width: 100%;
  margin-top: 5px;
  height: 209px;
}
@keyframes ScaleImg {
  0%{
    transform: scale(1);
  }
  50%{
    transform: scale(1.1);
  }
  100%{
    transform: scale(1);
  }
}
.img>img:hover{
  -webkit-animation: ScaleImg 3s linear 1;
}


ul{
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.title{
  padding-bottom: 8px;
  border-bottom: 1px solid #e7e7e7;
  height: 27px;
}
.title>a{
  margin-top: 10px;
  float: right;text-decoration: none;color: #999999;
  vertical-align: center;
  font-size: 16px;
}
.title>a:hover{
  text-decoration: underline;
  color: #088A29;
}
.con{
  font-size: 20px;
  font-weight: 900;
  color: #088A29;
}
li>span{
  display: block;
  float: right;
  height: 100%;
  font-size: 12px;
}
li>a{
  display: inline-block;
  height: 100%;
  width: 69%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  font-size: 16px;
  color: #000000;
  text-decoration: none;
}
li>a:hover{
  color: #088A29;
  text-decoration: underline;
}
li{
  height: 20px;
 margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Tabs1.vue